module.exports = __webpack_public_path__ + "assets/img/not_data_tips-c28c4806.png";